export enum GregorioBar {
  NO_BAR,
  
  VIRGULA,
  VIRGULA_HIGH,
  VIRGULA_PAREN,
  VIRGULA_PAREN_HIGH,

  DIVISIO_MINIMA,
  DIVISIO_MINIMA_HIGH,
  DIVISIO_MINIMA_PAREN,
  DIVISIO_MINIMA_PAREN_HIGH,

  DIVISIO_MINOR,
  DIVISIO_MINOR_D1,
  DIVISIO_MINOR_D2,
  DIVISIO_MINOR_D3,
  DIVISIO_MINOR_D4,
  DIVISIO_MINOR_D5,
  DIVISIO_MINOR_D6,
  DIVISIO_MINOR_D7,
  DIVISIO_MINOR_D8,

  DIVISIO_MAIOR,
  DIVISIO_MAIOR_DOTTED,

  DIVISIO_MINIMIS,
  DIVISIO_MINIMIS_HIGH,

  DIVISIO_FINALIS,
}
